import { roundNumber } from '../../../services/common/formatNew';

export const calculateAnnualMileage = (contractMileage: number, duration: string | number | undefined) => {
  if (!duration) return 0;
  return roundNumber((contractMileage / Number(duration)) * 12, 1);
};

export const calculateContractMileage = (annualMileage: number, duration: string | number | undefined) => {
  if (!duration) return 0;
  return roundNumber((annualMileage / 12) * Number(duration), 5000);
};

export const calculateContractMileageAfterDurationChange = (
  oldContractMileage: number,
  newDuration: number | undefined,
  oldDuration: number | undefined
) => {
  if (!newDuration || !oldDuration) return 0;
  return roundNumber((newDuration / oldDuration) * oldContractMileage, 5000);
};

export const calculateFinancedAmount = (vehicleTotalCost: number, totalDiscountAmount: number | undefined) => {
  return vehicleTotalCost - (totalDiscountAmount ?? 0);
};

export const calculateFirstInstallmentAmountPercentage = (
  firstInstallmentAmount: number | undefined,
  financedAmount: number
) => {
  if (!firstInstallmentAmount) return 0;
  return roundNumber(100 * (firstInstallmentAmount / financedAmount));
};

export const calculateFirstInstallmentAmount = (
  firstInstallmentAmountPercentage: number | undefined,
  financedAmount: number
) => {
  if (!firstInstallmentAmountPercentage) return 0;
  return roundNumber((financedAmount * firstInstallmentAmountPercentage) / 100);
};

export const calculateDownPaymentAmountPercentage = (downPaymentAmount: number | undefined, financedAmount: number) => {
  if (!downPaymentAmount) return 0;
  return roundNumber(100 * (downPaymentAmount / financedAmount));
};

export const calculateDownPaymentAmount = (downPaymentAmountPercentage: number, financedAmount: number) => {
  return roundNumber((financedAmount * downPaymentAmountPercentage) / 100);
};

export const calculateMaxEligibility = (dealerEffortMax: number, serviceBonus: number) => {
  return roundNumber((dealerEffortMax * serviceBonus) / 100);
};

export const getSumOfCarModelOptionsGrossCosts = (quote: QuoteSchema.Schemas.QuoteResponse) => {
  const options = quote.vehicleData?.model?.options;

  if (!options) return 0;

  return (
    options?.reduce((sum, { isSelected, optionPriceAmount }) => {
      return isSelected ? sum + (optionPriceAmount?.grossAmount ?? 0) : sum;
    }, 0) ?? 0
  );
};

/**
 * - Delivery options include both stricte delivery and registration costs.
 */
export const getSumOfDeliveryOptionsGrossCosts = (quote: QuoteSchema.Schemas.QuoteResponse) => {
  const offer = quote.financialProduct?.offers?.[0];

  if (!offer) return 0;

  return (
    // Get the only delivery option (implied as the one selected) and crawl it's components
    offer?.deliveryOptions?.[0].deliveryCostComponents?.reduce((sum, { deliveryCostAmount }) => {
      return sum + (deliveryCostAmount?.grossAmount ?? 0);
    }, 0) ?? 0
  );
};

export const calculateQuoteFinancedAmount = (quote: QuoteSchema.Schemas.QuoteResponse) => {
  return quote?.financialProduct?.offers?.[0]?.calculation?.grossLoanAmount?.grossAmount ?? 0;
};

export const calculateVehicleTotalCost = (stepValues, originalCatalogPrice) => {
  if (!stepValues) return '0,00';
  return (
    Number(stepValues?.accessoires || 0) +
    Number(stepValues?.totalRegCost || 0) +
    Number(stepValues?.catalogPrice || originalCatalogPrice || 0) +
    Number(stepValues?.options || 0) +
    Number(stepValues?.freeOptionsBTO || 0) +
    Number(stepValues?.deliveryCost || 0)
  )
    .toFixed(2)
    .replace('.', ',');
};
